import request from "@/utils/request";

export function getCategoryData() {
  return request.get("/api/mts-api/recCategory/list");
}

export function listCategory(query) {
  return request({
    url: "/api/mts-api/goods/category/list",
    method: "get",
    params: query,
  });
}
